import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import moment from 'moment';
import CardHeader from '../../../components/CardHeader';
import Toast from '../../../components/Toast';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../components/CustomOverlay';
import { dataService } from '../../../services/data.services';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { downloadS3Object } from '../../../CommonMethods/S3DownloadHook';
import { getNoticeTypeLabel } from '../Classroom/noticeTypeUtils';

export default function ViewBroadcast() {
    const { id } = useParams();
    const location = useLocation();
    const [toastErrorMessage, setToastErrorMessage] = useState('');
    const [pageLoading, setPageLoading] = useState(true);
    const [broadcast, setBroadcast] = useState(null);

    useEffect(() => {
        const loadBroadcast = async () => {
            try {
                const branch_id = await GetBranchId();
                const res = await dataService.GetAPI(`notice-board/broadcasts/${id}?branch_id=${branch_id}`);
                setBroadcast(res.data?.data?.data || res.data?.data || null);
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || 'Something went wrong while loading');
            } finally {
                setPageLoading(false);
            }
        };

        loadBroadcast();
    }, [id]);

    const handleAttachmentDownload = async (attachment) => {
        if (!attachment?.key) return;
        try {
            await downloadS3Object(attachment.key);
        } catch {
            setToastErrorMessage('Unable to download attachment');
        }
    };

    const backLocation = location.state?.broadcastContext?.listUrl
        || (location.search ? `/noticeboard/broadcasts${location.search}` : '/noticeboard/broadcasts?page_number=1');

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="View Broadcast"
                isback={true}
                backLocation={backLocation}
            />
            {toastErrorMessage !== '' && (
                <Toast message={toastErrorMessage} type="error" setToastmessage={setToastErrorMessage} />
            )}
            {pageLoading && (
                <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center 
                items-center sidebarOpenedOverlay" />
            )}
            {!pageLoading && (
                <div className="mainDataCntnrPageDiv scrollBlue_thick">
                    <div className="2xl:w-[60%] w-[80%] mx-auto">
                        <div className="border rounded border-[#D0D5DD]  p-3 mb-6 2xl:w-[70%] xl:w-[85%] m-auto bg-white">
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4 items-start">
                                <div className="flex items-center gap-2">
                                    <p className="min-w-[120px]">Academic Year</p>
                                    <p className="font-semibold">{broadcast?.academic_year_name || '-'}</p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <p className="min-w-[100px]">Type</p>
                                    <p className="font-semibold">
                                        {getNoticeTypeLabel(broadcast?.type, [], broadcast?.type || '-')}
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <p className="min-w-[120px]">Added Date</p>
                                    <p className="font-semibold">
                                        {broadcast?.date ? moment(broadcast.date).format('MMM DD, YYYY') : '-'}
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <p className="min-w-[100px]">Added by</p>
                                    <p className="font-semibold">
                                        {broadcast?.created_by_name || '-'}
                                    </p>
                                </div>
                                
                            </div>
                        </div>

                        <div className="border border-[#D0D5DD] p-3 rounded mt-4">
                            <div className="flex items-start mb-4">
                                <p className="min-w-[130px]">Title</p>
                                <p className="font-semibold w-full">{broadcast?.title || '-'}</p>
                            </div>

                            <div className="flex items-start mb-4">
                                <p className="min-w-[130px]">Description</p>
                                <p className="w-full whitespace-pre-wrap">
                                    {broadcast?.description || '-'}</p>
                            </div>

                            <div className="flex items-start">
                                <p className="min-w-[130px] mt-3">Attachments</p>
                                <div className="w-full">
                                    {(broadcast?.attachments || []).length > 0 ? (
                                        broadcast.attachments.map((att, index) => (
                                            <div key={`${att.key}-${index}`} className="flex items-center gap-2 mb-2">
                                                <button
                                                    type="button"
                                                    className="text-[#106EB4] underline text-left"
                                                    onClick={() => handleAttachmentDownload(att)}
                                                >
                                                    {att.name}
                                                </button>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-[#031624]">-</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </CardHeader>
    );
}
